import type { ListedBuilding } from 'contracts/Buildings';

const sanitizeAreaName = (value: string): string =>
  value.replace(/[^a-zA-ZÀ-ÿ0-9_ ]/g, '');

export const normalizeAreaCode = (value: string): string =>
  sanitizeAreaName(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ /g, '_')
    .toUpperCase()
    .slice(0, 50);

/**
 * A lista de áreas mostra quantos prédios cada uma tem. A contagem vem da lista
 * completa de prédios já carregada pela tela, para não exigir um endpoint de
 * contagem só para isso.
 */
export const countBuildingsByArea = (
  buildings: ListedBuilding[]
): Record<number, number> =>
  buildings.reduce<Record<number, number>>((totals, { areaId }) => {
    totals[areaId] = (totals[areaId] ?? 0) + 1;
    return totals;
  }, {});
